import ChecklistOutlinedIcon from '@mui/icons-material/ChecklistOutlined';

export const warehouseStockReplenishConfig = {
    all:  {
        title: 'replenish_lists',
        icon: <ChecklistOutlinedIcon/>,
        isSingleDataGrid: true,
    },
    replenishLines:  {
        title: 'replenish_lines',
        icon: <ChecklistOutlinedIcon/>,
        isSingleDataGrid: true,
    },
};
